import React, { Component } from 'react';
import { Route, Link, withRouter, Redirect } from 'react-router-dom';
import Firebase from 'firebase';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';


export default class Header extends React.Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      login: true,
      tab: "account"
    };
    this.logOut = this.logOut.bind(this);
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  logOut() {
    const contex = this;
    Firebase.auth().signOut().then(resp => {
      localStorage.removeItem("uid");
      localStorage.removeItem("client_id");
      this.setState({ login: false });
      localStorage.clear();
    });
  }

  componentDidMount() {
    const contex = this;
    Firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        var userRef = Firebase.database().ref('admin_users').child(user.uid).on('value', snap => {
          contex.setState({ user: snap.val(), ready: true });
          if (snap.val().photo) {
            if (document.getElementById('photo')) {
              document.getElementById('photo').src = snap.val().photo;
            }
          }
        })
      }
    });
  }


  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }


  render() {
    switch (this.state.login) {
      case false:
        return (
          <Redirect to="/login" />
        )
      case true:
        return (
          <header className="app-header navbar" style={{ background: "#FFF", borderBottom: "3px solid #ccc", boxShadow: "0 4px 4px rgba(0,0,0,0.1)" }}>
            <button className="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" onClick={this.mobileSidebarToggle}>&#9776;</button>
            <a className="navbar-brand" style={{ cursor: "pointer" }}></a>
            <button className="nav-link  navbar-toggler sidebar-toggler" type="button" onClick={this.sidebarToggle}>&#9776;</button>
            <ul className="nav navbar-nav d-md-down-none" style={{ cursor: "pointer" }}>
              <Link className="nav-item px-2" to="/cuenta" onClick={() => { this.setState({ tab: "account" }); localStorage.setItem("url", "cuenta") }}>
                Cuenta
                </Link >
              <Link className="nav-item px-2" to="/usuarios" onClick={() => { this.setState({ tab: "users" }); localStorage.setItem("url", "usuarios") }}>
                Usuarios
                </Link >
              <Link className="nav-item px-2" to="/locales" onClick={() => { this.setState({ tab: "stores" }); localStorage.setItem("url", "locales") }}>
                Locales
                </Link >
              <Link className="nav-item px-2" to="/set-de-datos" onClick={() => { this.setState({ tab: "datasets" }); localStorage.setItem("url", "set-de-datos") }}>
                Set de datos
                </Link >
              <Link className="nav-item px-2" to="/registros" onClick={() => { this.setState({ tab: "reg" }); localStorage.setItem("url", "registros") }}>
                Registros
                </Link >
              <Link className="nav-item px-2" to="/historial" onClick={() => { this.setState({ tab: "history" }); localStorage.setItem("url", "historial") }}>
                Historial
                </Link >
              <Link className="nav-item px-2" to="/formularios" onClick={() => { this.setState({ tab: "forms" }); localStorage.setItem("url", "formularios") }}>
                Formularios
                </Link >
              <li className="nav-item">
                <Dropdown isOpen={this.state.dropdownGraficas} toggle={() => this.setState({ dropdownGraficas: !this.state.dropdownGraficas })}>
                  <button onClick={() => this.setState({ dropdownGraficas: !this.state.dropdownGraficas })} className="nav-link  dropdown" aria-expanded={this.state.dropdownGraficas}>
                    <span className="nav-item px-2" style={{ color: "#4183c4" }}>Graficas</span>
                  </button>
                  <DropdownMenu className="dropdown-menu-right">
                    {
                      localStorage.trial ?
                        <Link className="dropdown-item" style={{ color: "#4183c4" }} to="/dashboard" onClick={() => { this.setState({ tab: "dashboard" }); localStorage.setItem("url", "dashboard") }}>
                          Premium
                          </Link >
                        :
                        ""
                    }
                    <Link className="dropdown-item" style={{ color: "#4183c4" }} to="/control" onClick={() => { this.setState({ tab: "haiti" }); localStorage.setItem("url", "haiti") }}>
                      Control Asistencia
                      </Link >
                  </DropdownMenu>
                </Dropdown>
              </li>
              <a href="https://operatio.zendesk.com/hc/es" target="_blank" onClick={() => { this.setState({ tab: "help" }); localStorage.setItem("url", "users") }}>
                Ayuda
                </a>
            </ul>
            <ul className="nav navbar-nav ml-auto">
              <li className="nav-item">
                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} style={{ marginRight: "10px" }}>
                  <button onClick={this.toggle} className="nav-link  dropdown-toggle" data-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
                    <img src='/public/img/avatar.png' id="photo" className="img-avatar" />
                    <span className="d-md-down-none">{localStorage.email ? localStorage.email : ""}</span>
                  </button>

                  <DropdownMenu className="dropdown-menu-right">
                    <DropdownItem onClick={() => this.logOut()} ><i className="fa fa-lock"></i>Cerrar sesión</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </li>
            </ul>
          </header >
        )
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/Header.js